import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import MyDrives from './components/MyDrives';

const myDrives = (props,{ t }) => (
  <Container>
    <MyDrives {...props} />
  </Container>
);

myDrives.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(myDrives);
